<template>
  <div class="PostAttachments">
    <Gallery
      v-if="files.length > 0"
      class="attachments"
      :grid="true"
      :nsfw="false"
      :attachments="files"
      :descriptions="descriptions"
      :editable="true"
      :edit-attachment="describe"
      :remove-attachment="remove"
      :shift-up-attachment="files.length > 1 && ((file) => move(file, -1))"
      :shift-dn-attachment="files.length > 1 && ((file) => move(file, 1))"
      @play="$emit('play')"
      @pause="$emit('pause')"
    />
    <div
      v-if="files.length > 0 && !hideSensitive"
      class="upload_settings"
    >
      <Checkbox
        :model-value="nsfw"
        @update:model-value="$emit('update:nsfw', $event)"
      >
        {{ $t('post_status.attachments_sensitive') }}
      </Checkbox>
    </div>
    <div
      v-show="dropIcon !== 'hide'"
      :style="{ animation: dropIcon === 'show' ? 'fade-in 0.25s' : 'fade-out 0.5s' }"
      class="drop-indicator"
      @dragleave="dragStop"
      @drop.stop="drop"
    >
      <FAIcon :icon="full ? 'ban' : 'upload'" />
    </div>
  </div>
</template>

<script src="./post_attachments.js"></script>

<style lang="scss">
/* its parts sit in the form's column; the indicator covers the form */
.PostAttachments {
  display: contents;

  .attachments {
    margin-bottom: 0.5em;
  }

  @keyframes fade-in {
    from { opacity: 0; }
    to { opacity: 0.6; }
  }

  @keyframes fade-out {
    from { opacity: 0.6; }
    to { opacity: 0; }
  }

  .drop-indicator {
    position: absolute;
    inset: 0;
    z-index: var(--ZI_floating);
    font-size: 5em;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.6;
    color: var(--text);
    background-color: var(--bg);
    border-radius: var(--roundness);
    border: 2px dashed var(--text);
  }
}
</style>
